import * as React from 'react';
import './Admin.less';
import { Form, Input, Button, Select, Checkbox, DatePicker, Divider, message, Spin, InputNumber, Row, Col } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Moment } from 'moment';
import moment from 'moment';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import AddClientSubscriptionDTO from 'src/models/client/AddClientSubscriptionDTO';
import UpdateClientSubscriptionDTO from 'src/models/client/UpdateClientSubscriptionDTO';
import KeyValueListDTO from 'src/models/generic/KeyValueListDTO';
import KeyValueDTO from 'src/models/generic/KeyValueDTO';
import ClientApiController from 'src/api/ClientApiController';


interface RouteParams {
    clientId: string;
    clientSubscriptionId: string;
}

interface AddEditClientSubscriptionProps extends PageProps<RouteParams>, LocalizeContextProps { }

interface AddEditClientSubscriptionState {
    loading: boolean;
    isSubmitting: boolean;
    currentClientSubscription: UpdateClientSubscriptionDTO;
    clientId: number;
    redirect: boolean;
}

interface ClientSubscriptionFormProps {
    currentClientSubscription: UpdateClientSubscriptionDTO;
    clientId: number;
    translate: (id: any) => any;
    onChange: (changedFields: any[]) => void;
}

// Form
let ClientSubscriptionForm = Form.create({
    onFieldsChange(props: ClientSubscriptionFormProps, changedFields: any[]) {
        props.onChange(changedFields);
    }
})(class extends React.Component<ClientSubscriptionFormProps & FormComponentProps> {
    constructor(props: ClientSubscriptionFormProps & FormComponentProps) {
        super(props);
    }

    private getInitialDateValue(date: Moment): Moment {
        return date ? moment(date, 'YYYY-MM-DD') : null;
    }

    private renderStandardFormItem(translationId: string, id: string, initialValue, inputType, visible: boolean = true, required: boolean = true) {
        let translatedLabel = this.props.translate(translationId);

        if (visible) {
            return (
                <Form.Item label={translatedLabel}>
                    {this.props.form.getFieldDecorator(id, {
                        initialValue: initialValue,
                        rules: [{ required: required, message: this.props.translate('admin.common.requiredRule') }]
                    })(inputType)}
                </Form.Item>
            );
        }
    }

    render() {
        let dateFormat = "M/D/YYYY";

        return (
            <Row>
                <Col span={12}>
                    <Form className="admin-form">
                        {this.renderStandardFormItem(
                            "admin.addEditClientSubscription.formItem1",
                            "maximumUserCount",
                            this.props.currentClientSubscription.maximumUserCount,
                            <InputNumber autoComplete="off" min={0}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => parseInt(value.replace(/\$\s?|(,*)/g, ''), 10) || 0} />
                        )}

                        {this.renderStandardFormItem(
                            "admin.addEditClientSubscription.formItem2",
                            "subscriptionStartDate",
                            this.getInitialDateValue(this.props.currentClientSubscription.subscriptionStartDate),
                            this.props.currentClientSubscription.clientSubscriptionId ?
                                <DatePicker format={dateFormat} disabled /> :
                                <DatePicker format={dateFormat} disabledDate={(current) => current && this.props.currentClientSubscription.subscriptionExpirationDate && current > this.props.form.getFieldValue('subscriptionExpirationDate')} />
                        )}

                        {this.renderStandardFormItem(
                            "admin.addEditClientSubscription.formItem3",
                            "subscriptionExpirationDate",
                            this.getInitialDateValue(this.props.currentClientSubscription.subscriptionExpirationDate),
                            <DatePicker format={dateFormat} disabledDate={(current) => current && this.props.currentClientSubscription.subscriptionStartDate && current < this.props.form.getFieldValue('subscriptionStartDate')} />
                        )}

                        {this.renderStandardFormItem(
                            "admin.addEditClientSubscription.formItem4",
                            "isActive",
                            this.props.currentClientSubscription.isActive,
                            <Checkbox checked={this.props.currentClientSubscription.isActive} />,
                            this.props.currentClientSubscription.clientSubscriptionId ? true : false
                        )}
                    </Form>
                </Col>
            </Row>
        );
    }
});

class AddEditClientSubscription extends React.Component<AddEditClientSubscriptionProps, AddEditClientSubscriptionState> {
    private formRef: React.Component<FormComponentProps>;

    constructor(props: AddEditClientSubscriptionProps) {
        super(props);
        bindAllOfThis(this, AddEditClientSubscription.prototype);

        let clientId = parseInt(this.props.match.params.clientId, 10);
        let clientSubscriptionId = parseInt(this.props.match.params.clientSubscriptionId, 10);

        let currentClientSubscription: UpdateClientSubscriptionDTO = {
            clientSubscriptionId: clientSubscriptionId,
            isActive: false,
            maximumUserCount: null,
            subscriptionStartDate: null,
            subscriptionExpirationDate: null
        };

        this.state = {
            loading: true,
            isSubmitting: false,
            redirect: false,
            clientId: clientId,
            currentClientSubscription: currentClientSubscription
        };
    }

    componentWillMount() {
        this.fillForm();
    }

    private fillForm(): void {
        if (this.state.currentClientSubscription.clientSubscriptionId) {
            ClientApiController.getClientSubscription(this.state.currentClientSubscription.clientSubscriptionId)
                .then((result) => {
                    this.setState({
                        loading: false,
                        currentClientSubscription: result.data
                    });
                }).catch(e => {
                    message.error(this.props.translate('admin.addEditClientSubscription.messageRetrieveError'));
                });
        } else {
            this.setState({
                loading: false
            });
        }
    }

    private handleInputChange(changedFields: any[]): void {
        let newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                let field: any = changedFields[key];
                newState[key] = field.value;
            }
        }

        this.setState({
            currentClientSubscription: { ...this.state.currentClientSubscription, ...newState }
        });
    }

    private addClientSubscription(): void {
        let addClientSubscriptionDTO: AddClientSubscriptionDTO = {
            clientId: this.state.clientId,
            isActive: true,
            maximumUserCount: this.state.currentClientSubscription.maximumUserCount,
            subscriptionStartDate: this.state.currentClientSubscription.subscriptionStartDate,
            subscriptionExpirationDate: this.state.currentClientSubscription.subscriptionExpirationDate
        };

        ClientApiController.addClientSubscription(addClientSubscriptionDTO)
            .then(result => {
                message.success(this.props.translate('admin.addEditClientSubscription.messageAdd'));
                this.setState({ redirect: true, isSubmitting: false });
            }).catch(e => {
                message.error(this.props.translate('admin.addEditClientSubscription.messageAddError'));
                this.setState({ isSubmitting: false });
            });
    }

    private updateClientSubscription(): void {
        ClientApiController.updateClientSubscription(this.state.currentClientSubscription)
            .then(result => {
                this.setState({ isSubmitting: false });
                if (result.data.isSuccess) {
                    message.success(this.props.translate('admin.addEditClientSubscription.messageUpdate'));
                    this.setState({ redirect: true });
                }
                else {
                    message.error(result.data.errorMessage);
                }
            }).catch(e => {
                message.error(this.props.translate('admin.addEditClientSubscription.messageUpdateError'));
                this.setState({ isSubmitting: false });
            });
    }

    private handleSubmit(e): void {
        e.preventDefault();

        this.formRef.props.form.validateFields((error: any, values: any) => {
            if (!error) {
                this.setState({ isSubmitting: true });
                this.state.currentClientSubscription.clientSubscriptionId ?
                    this.updateClientSubscription() :
                    this.addClientSubscription();
            }
        });
    }

    private handleCancel(e): void {
        this.setState({ redirect: true });
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLIENT, this.state.clientId)} push />;
        } else if (this.state.loading) {
            return <Spin />;
        }

        let formProps = {
            currentClientSubscription: this.state.currentClientSubscription,
            clientId: this.state.clientId,
            translate: this.props.translate,
            onChange: this.handleInputChange
        } as ClientSubscriptionFormProps;

        return (
            <div>
                <h2>
                    {this.state.currentClientSubscription.clientSubscriptionId ?
                        this.props.translate("admin.addEditClientSubscription.editHeader") :
                        this.props.translate("admin.addEditClientSubscription.addHeader")}
                </h2>

                <ClientSubscriptionForm wrappedComponentRef={ref => this.formRef = ref} {...formProps} />

                <div>
                    <Button type="primary" onClick={this.handleSubmit} loading={this.state.isSubmitting}>
                        {this.props.translate("admin.common.saveButton")}
                    </Button>
                    <Divider type="vertical" />
                    <Button onClick={this.handleCancel}>
                        {this.props.translate("common.back")}
                    </Button>
                </div>
            </div>
        );
    }
}

export default withLocalize(AddEditClientSubscription);



// WEBPACK FOOTER //
// ./src/pages/admin/AddEditClientSubscription.tsx